import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilChartPie,
  cilSpeedometer,
  cilUser,
  cilUserFemale,
  cilGroup,
  cilTask,
  cilSettings,
  cilChart,
  cilEducation,
  cilPeople,
  cilLibrary,
  cilClock,
  cilMoney,
  cilEnvelopeOpen,
  cilReportSlash,
  cilLockLocked,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    permission: { viewCode: 'dashboard', actionCode: 'view' },
  },
  {
    component: CNavTitle,
    name: 'Academic Management',
  },
  {
    component: CNavGroup,
    name: 'Courses',
    to: '/courses',
    icon: <CIcon icon={cilEducation} customClassName="nav-icon" />,
    permission: { resource: 'courses', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator'],
    items: [
      {
        component: CNavItem,
        name: 'All Courses',
        to: '/courses',
        permission: { resource: 'courses', action: 'list' },
      },
      {
        component: CNavItem,
        name: 'Create Course',
        to: '/courses/create',
        permission: { resource: 'courses', action: 'create' },
      },
      {
        component: CNavItem,
        name: 'Course Categories',
        to: '/courses/categories',
        permission: { resource: 'courses', action: 'list' },
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Student Groups',
    to: '/groups',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    permission: { resource: 'groups', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor'],
    items: [
      {
        component: CNavItem,
        name: 'All Groups',
        to: '/groups',
        permission: { resource: 'groups', action: 'list' },
      },
      {
        component: CNavItem,
        name: 'Create Group',
        to: '/groups/create',
        permission: { resource: 'groups', action: 'create' },
        allowedRoles: ['super-admin', 'ceo', 'coordinator'],
      },
      {
        component: CNavItem,
        name: 'Group Types',
        to: '/admin/group-types',
        permission: { resource: 'groups', action: 'read' },
        allowedRoles: ['super-admin', 'ceo', 'coordinator'],
      },
      {
        component: CNavItem,
        name: 'Group Schedules',
        to: '/groups/schedules',
        permission: { resource: 'groups', action: 'list' },
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Lectures',
    to: '/lectures',
    icon: <CIcon icon={cilLibrary} customClassName="nav-icon" />,
    permission: { resource: 'lectures', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor', 'student'],
    items: [
      {
        component: CNavItem,
        name: 'All Lectures',
        to: '/lectures',
        permission: { resource: 'lectures', action: 'list' },
      },
      {
        component: CNavItem,
        name: 'Schedule Lecture',
        to: '/lectures/schedule',
        permission: { resource: 'lectures', action: 'create' },
        allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor'],
      },
      {
        component: CNavItem,
        name: 'Lecture Calendar',
        to: '/lectures/calendar',
        permission: { resource: 'lectures', action: 'list' },
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Attendance',
    to: '/attendance',
    icon: <CIcon icon={cilClock} customClassName="nav-icon" />,
    permission: { viewCode: 'attendance', actionCode: 'view' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor', 'student', 'parent'],
    items: [
      {
        component: CNavItem,
        name: 'Overview',
        to: '/attendance',
        permission: { viewCode: 'attendance', actionCode: 'view' },
      },
      {
        component: CNavItem,
        name: 'Mark Attendance',
        to: '/attendance/mark',
        permission: { viewCode: 'attendance.mark', actionCode: 'mark' },
        allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor'],
      },
      {
        component: CNavItem,
        name: 'Reports',
        to: '/attendance/reports',
        permission: { viewCode: 'attendance.reports', actionCode: 'view' },
        allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor'],
      },
      {
        component: CNavItem,
        name: 'My Attendance',
        to: '/attendance/my',
        permission: { viewCode: 'attendance.my', actionCode: 'view' },
        allowedRoles: ['student'],
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Homework',
    to: '/homework',
    icon: <CIcon icon={cilTask} customClassName="nav-icon" />,
    permission: { resource: 'homework', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor', 'student'],
    items: [
      {
        component: CNavItem,
        name: 'All Assignments',
        to: '/homework',
        permission: { resource: 'homework', action: 'list' },
      },
      {
        component: CNavItem,
        name: 'Create Assignment',
        to: '/homework/create',
        permission: { resource: 'homework', action: 'create' },
        allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor'],
      },
      {
        component: CNavItem,
        name: 'Submissions',
        to: '/homework/submissions',
        permission: { resource: 'homework', action: 'list' },
        allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor'],
      },
    ],
  },
  {
    component: CNavTitle,
    name: 'User Management',
  },
  {
    component: CNavGroup,
    name: 'Users',
    to: '/users',
    icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    permission: { resource: 'users', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator'],
    items: [
      {
        component: CNavItem,
        name: 'All Users',
        to: '/users',
        permission: { resource: 'users', action: 'list' },
      },
      {
        component: CNavItem,
        name: 'Add User',
        to: '/users/add',
        permission: { resource: 'users', action: 'create' },
      },
      {
        component: CNavItem,
        name: 'Roles & Permissions',
        to: '/users/roles',
        permission: { resource: 'roles', action: 'list' },
        allowedRoles: ['super-admin'],
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Students',
    to: '/students',
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    permission: { resource: 'users', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator', 'professor'],
  },
  {
    component: CNavItem,
    name: 'Professors',
    to: '/professors',
    icon: <CIcon icon={cilUserFemale} customClassName="nav-icon" />,
    permission: { resource: 'users', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator'],
  },
  {
    component: CNavItem,
    name: 'Parents',
    to: '/parents',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    permission: { resource: 'users', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator'],
  },
  {
    component: CNavTitle,
    name: 'Financial Management',
  },
  {
    component: CNavGroup,
    name: 'Payments',
    to: '/payments',
    icon: <CIcon icon={cilMoney} customClassName="nav-icon" />,
    permission: { resource: 'payments', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator', 'student', 'parent'],
    items: [
      {
        component: CNavItem,
        name: 'All Payments',
        to: '/payments',
        permission: { resource: 'payments', action: 'list' },
      },
      {
        component: CNavItem,
        name: 'Payment Due',
        to: '/payments/due',
        permission: { resource: 'payments', action: 'list' },
      },
      {
        component: CNavItem,
        name: 'Payment History',
        to: '/payments/history',
        permission: { resource: 'payments', action: 'list' },
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Financial Reports',
    to: '/reports/financial',
    icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
    permission: { resource: 'reports', action: 'read' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator'],
  },
  {
    component: CNavTitle,
    name: 'Communication',
  },
  {
    component: CNavItem,
    name: 'Notifications',
    to: '/notifications',
    icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
    permission: { viewCode: 'notifications', actionCode: 'view' },
  },
  {
    component: CNavItem,
    name: 'Messages',
    to: '/messages',
    icon: <CIcon icon={cilEnvelopeOpen} customClassName="nav-icon" />,
    permission: { viewCode: 'messages', actionCode: 'view' },
  },
  {
    component: CNavTitle,
    name: 'Reports & Analytics',
  },
  {
    component: CNavGroup,
    name: 'Reports',
    to: '/reports',
    icon: <CIcon icon={cilReportSlash} customClassName="nav-icon" />,
    permission: { resource: 'reports', action: 'list' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator'],
    items: [
      {
        component: CNavItem,
        name: 'Academic Reports',
        to: '/reports/academic',
        permission: { resource: 'reports', action: 'read' },
      },
      {
        component: CNavItem,
        name: 'Attendance Reports',
        to: '/reports/attendance',
        permission: { resource: 'reports', action: 'read' },
      },
      {
        component: CNavItem,
        name: 'Performance Reports',
        to: '/reports/performance',
        permission: { resource: 'reports', action: 'read' },
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Analytics',
    to: '/analytics',
    icon: <CIcon icon={cilChartPie} customClassName="nav-icon" />,
    permission: { resource: 'reports', action: 'read' },
    allowedRoles: ['super-admin', 'ceo', 'coordinator'],
  },
  {
    component: CNavTitle,
    name: 'System',
  },
  {
    component: CNavItem,
    name: 'Settings',
    to: '/settings',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    permission: { viewCode: 'settings', actionCode: 'view' },
  },
  {
    component: CNavGroup,
    name: 'Administration',
    to: '/admin',
    icon: <CIcon icon={cilLockLocked} customClassName="nav-icon" />,
    permission: { resource: 'roles', action: 'list' },
    allowedRoles: ['super-admin'],
    items: [
      {
        component: CNavItem,
        name: 'Role Management',
        to: '/admin/roles',
        permission: { resource: 'roles', action: 'list' },
      },
      {
        component: CNavItem,
        name: 'Views Management',
        to: '/admin/views',
        permission: { resource: 'system', action: 'admin' },
      },
      {
        component: CNavItem,
        name: 'Role Permissions',
        to: '/admin/permissions',
        permission: { resource: 'system', action: 'admin' },
      },
      {
        component: CNavItem,
        name: 'Group Types',
        to: '/admin/group-types',
        permission: { resource: 'groups', action: 'read' },
      },
      {
        component: CNavItem,
        name: 'System Settings',
        to: '/admin/settings',
        permission: { resource: 'system', action: 'admin' },
      },
    ],
  },
]

export default _nav
